// components/features/sms/SmsList.tsx

import { Sms } from "../../../types/features/Sms";
import TableList, { SelectAction } from "../../ui/TableList";
import SmsRow from "./SmsRow";

interface SmsListProps {
  smsList: Sms[];
  onAction: (sms: Sms) => void;
  onResend?: (smsId: string, recipientId: string) => Promise<void>;
  onSelectSms?: (selectedSms: Sms[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function SmsList({
  smsList,
  onAction,
  onResend,
  onSelectSms,
  selectable = false,
  selectActions,
}: SmsListProps) {
  const columns = [
    { header: "Message / Détails", className: "w-3/5" },
    { header: "Statut", className: "w-1/5" },
    { header: "", className: "w-1/5 text-right" },
  ];

  return (
    <TableList
      items={smsList}
      columns={columns}
      getId={(sms) => sms.id}
      onAction={onAction}
      onSelectItems={onSelectSms}
      selectable={selectable}
      emptyMessage="Aucun SMS envoyé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(sms, isSelected, onSelect) => (
        <SmsRow
          key={sms.id}
          sms={sms}
          onAction={onAction}
          onResend={onResend}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}
